export const setAuth = (token, tokenType, user) => {
    localStorage.setItem('ums_token', token);
    localStorage.setItem('ums_token_type', tokenType);
    localStorage.setItem('ums_user', JSON.stringify(user));
    console.log(token, tokenType, user);
};

export const getToken = () => localStorage.getItem('ums_token');
export const getTokenTokenType = () => localStorage.getItem('ums_token_type');

export const getUser = () => {
    const user = localStorage.getItem('ums_user');
    return user ? JSON.parse(user) : null;
};

export const logout = () => {
    localStorage.removeItem('ums_token');
    localStorage.removeItem('ums_token_type');
    localStorage.removeItem('ums_user');
};
